export default __webpack_public_path__ + "static/media/Logo.843d6e78.svg";